import styled, { keyframes } from "styled-components";

const blinkingCursor = keyframes`
0%{
opacity:1}
100%{
opacity:0}`;

const moveUpward = keyframes`
0%{
transform:translateY(200px)}
100%{
transform:translateY(0px)}`;
const chantenteranimation = keyframes`
0%{
max-height:0px ;
opacity:0;
}
100%{
max-height:300px;
opacity:1;
}
`;

export const IndexDemoComponentMainDiv = styled.section`
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 40px;
    gap: 10px;
    width: 100%;
  }
  .index-demo-trigger {
  }
  .index-demo-container {
    max-width: 1140px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    width: 100%;
    flex: 1;
  }
  .index-demo-header-container {
    display: flex;
    align-item: center;
    gap: 40px;
    z-index: 1;
  }
  .index-demo-ai-header-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .index-demo-ai-header-icon-holder {
    height: 120px;
    width: 120px;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 100%;
    }
  }
  .index-demo-ai-header-text-holder {
    display: flex;
    align-items: center;
    white-space: pre;
    > h2 {
      font-size: 140px;
      font-weight: 500;
      line-height: 1.2em;
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
      padding: 0;
      text-transform: capitalize;
      margin: 0;
    }
  }
  .index-demo-ai-header-powered-text {
    animation: ${moveUpward} 2s linear;
    animation-timeline: view();
    animation-range: cover 0% cover 70%;
  }
  .index-demo-ai-header-powered-text-holder {
    background: linear-gradient(
      90deg,
      rgb(255, 223, 125) 39%,
      /* The Rich Base: Vibrant Gold */ rgb(195, 220, 250) 60%,
      /* The Metallic Flash: Icy Periwinkle */ rgb(80, 140, 245) 79%
        /* The Deep Pop: Vivid Cornflower Blue */
    );
    background-clip: text;
    color: transparent;
  }
`;

export const IndexDemoComponentDemoContainerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  > div {
    width: 100%;
  }
`;
export const IndexDemoComponentDemoContent = styled.div`
  flex: 1;
  width: 100%;

  > div {
    width: 100%;
  }
  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: end;
    padding: 40px 10px 10px;

    gap: 40px;
    overflow: hidden;
    overflow: hidden;
  }

  .window-frame {
    width: 100%;
    min-width: 400px;
    max-width: 1140px;
    height: 788px;
    background: rgba(0, 0, 0, 1);
    border-radius: 18px;
    display: flex;
    border: 1px solid #322c29;
    padding: 0.5rem;
  }

  .sidebar {
    border: 1px solid #322c29;
    border-radius: 18px;
    width: 24%;
    max-width: 300px;
    min-width: 250px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: var(--size-2);
  }
  .modal-header-holder {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .close-modal {
    display: flex;
    gap: 6px;
    div {
      width: 12px;
      height: 12px;
      background-color: red;
      border-radius: 1000px;
    }
    :nth-child(1) {
      background-color: #f95a5b;
    }
    :nth-child(2) {
      background-color: #f4c101;
    }
    :nth-child(3) {
      background-color: #37c156;
    }
  }
  .dashboard-logo-header {
    padding: 16px 0px 8px 2px;

    display: flex;
    align-items: Center;
    gap: 4px;
  }
  .test {
    height: 500px;
    overflow: hidden;
  }
  .dashboard-logo-holder {
    width: 32px;
    height: 32px;
  }
  .header-text {
    h4 {
      font-family: "General Sans", "General Sans Placeholder", sans-serif;
      white-space: pre;
      font-size: 20px;
      font-weight: 500;
      line-height: 1.2em;
      padding: 0;
      margin: 0;
      text-transform: capitalize;
    }
  }

  .dashboard-new-chat-button {
    width: 90%;
    border: 1px solid #322c29;
    padding: 8px;
    border-radius: 8px;

    font-family: "General Sans", "General Sans Placeholder", sans-serif;
    white-space: pre;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2em;
    text-transform: capitalize;
    > div {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;

      gap: 8px;
      align-items: center;
    }
    .new-icon-holder {
      width: 20px;
      height: 20px;
    }
    .small {
      width: 20px;
      height: 20px;
    }
  }
  .icon-medium {
    width: 24px;
    height: 24px;
  }
  .demo-modal-header {
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: space-between;
  }
  .chat-history-modal {
    display: flex;
    flex-direction: column;
    gap: var(--size-2);

    .chat-modal {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  .chat-modal-text {
    font-size: 16px;
    padding: 0;
    font-weight: 400;
    margin: 0;
    text-transform: capitalize;
  }
  .chat-modal-icon-holder {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .collapse-icon-holder {
    width: 16px;
    height: 15px;
    border: 1px solid white;
    margin: 8px 0 0;
    overflow: hidden;
    display: flex;
    gap: 0;
    &:before {
      content: "";
      width: 5px;
      height: 24px;
      display: flex;
      background: white;
    }
  }
  .chat-sidebar-item-container {
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: space-between;
    height: 100%;
  }
  .chat-sidebar-action-container {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 0 0 10px;
  }
  .chat-sidebar-action-icon-container {
    > svg {
      width: 19px;
      height: 19px;
    }
  }
  .chat-sidebar-action-text-container {
    > p {
      margin: 0;
      padding: 0px;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .demo-input-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .chat-bubble-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin: 0 auto;
    width: 80%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
`;

export const IndexDemoChatBoxContainer = styled.div`
  will-change: transform;
  width: 80%;
  top: 0;
  height: 100%;

  .chat-modal-container {
  }
  .chat-modal-content-holder {
    border-radius: 20px;
    display: flex;
    will-change: transform;
    align-items: center;
    gap: 0;
    width: 100%;
    padding: 6px;
    overflow: hidden;
  }

  .background-fill {
    background: rgba(0, 0, 0, 0);
    background-image: linear-gradient(
      270deg,
      rgb(165, 125, 25) 0.105574%,
      /* Dark Mustard/Gold */ rgb(161, 115, 69) 33.3685%,
      /* Deep Bronze/Brown */ rgb(0, 0, 0) 51.4886%,
      /* Pure Black Void */ rgb(97, 150, 242) 93.0708% /* Cinematic Blue Pop */
    );
    background-clip: border-box;
    background-origin: padding-box;
    position: absolute;
    inset: -345px -164px;
    transform: rotate(107deg);
    overflow: hidden;
  }
  .chat-modal-content {
    background: var(--main-bg);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 16px;
    overflow: hidden;
    flex: 1;
  }
  .chat-modal-content-section {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    flex: 1;
    > div {
      display: flex;
      gap: 8px;
    }
  }
  .chat-modal-model-selector {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #ffffff14;
    backdrop: blur(2px);
  }
  .chat-modal-selector {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #ffffff14;
    backdrop-filter: blur(2px);
  }
  .chat-modal-selector-large-padding {
    padding: 8px 12px;
  }
  .icon-container {
    image-rendering: pixelated;
    flex-shrink: 0;
    fill: var(--main-bg);
    color: var(--main-bg);
    opacity: 0.5;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }
    .small {
      width: 20px;
      height: 20px;
    }
  }
  .chat-modal-action-container {
    display: flex;
    gap: 8px;
  }
  .chat-modal-action-holder {
    justify-content: space-between;
  }
  .openai {
    color: white;
    width: 27px;
    height: 27px;
    padding: 0;
    margin: 0px;
  }
  .model-text-wrapper {
    justify-content: center;
    white-space: pre-wrap;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    word-break: break-word;
    width: 81px;
    > p {
      padding: 0;
      margin: 0;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .text-wrapper {
    justify-content: center;
    white-space: pre-wrap;
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    word-break: break-word;
    > p {
      padding: 0;
      margin: 0;
      font-size: 14px;
      font-weight: 500;
      text-transform: capitalize;
      font-family: Inter, "Inter Placeholder", sans-serif;
    }
  }
  .chat-modal-input-text {
    font-family: "Inter", "Inter Placeholder", sans-serif;
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0em;
    line-height: 1.2em;
    color: rgba(255, 255, 255, 0.8);
    padding: 0px;
    width: 100%;
    height: 100%;
    position: relative;
    > span {
    }
  }
  .blinking-cursor {
    color: rgba(255, 255, 255, 0.75);
    opacity: 1;
    animation: ${blinkingCursor} linear infinite 0.9s;
  }
`;

export interface IndexDemoComponenChatContentProp {
  isuser: boolean;
  isactive: boolean;
}
export const IndexDemoComponenChatContent = styled.div<IndexDemoComponenChatContentProp>`
  width: 100%;
  overflow: hidden;
  transition:
    max-height 0.3s ease,
    opacity 0.3s ease;
  animation: ${chantenteranimation} linear 1.5s;

  opacity: 1;
  .blinking-cursor {
    display: ${(p) => (p.isactive ? "flex-inline" : " none")};

    color: rgba(255, 255, 255, 0.75);
    opacity: 1;
    animation: ${blinkingCursor} linear infinite 0.9s;
  }
  > div {
    display: flex;
    justify-content: ${(p) => (p.isuser ? "flex-end" : " flex-start")};
    gap: 8px;
  }
  .chat-bubble-chat-container {
    border-radius: 16px;
    backdrop-filter: blur(2px);
    border: 1px solid rgba(255, 255, 255, 0.08);
    padding: 8px 1.4rem;
    flex: 1;
    display: flex;
  }
  .chat-bubble-chat-text-container {
    display: flex;
    align-items: center;
    > p {
      padding: 0;
      margin: 0;
      font-size: 16px;
      font-weight: 400;
      line-height: 1.2em;
      font-family: Inter, "Inter Placeholder", sans-serif;
    }
  }
  .chat-bubble-chat-icon-container {
    width: 3rem;
    height: 3rem;
    border-radius: 100%;
    padding: 1px;
    background: rgba(255, 255, 255, 0.08);
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 100%;
    }
  }
  .ai-icon {
    opacity: ${(p) => (p.isuser ? "0" : "1")};
  }
  .user-icon {
    opacity: ${(p) => (p.isuser ? "1" : "0")};
  }
`;

export const IndexDemoComponentUseCaseDiv = styled.div`
  display: grid;
  grid-template-rows: repeat(1fr, min-content);
  grid-template-columns: repeat(5, minmax(50px, 1fr));
  grid-auto-rows: min-content;
  justify-content: center;
  gap: 16px;
  width: 100%;
`;

export const IndexDemoComponentUseCaseItemDiv = styled.div`
  place-self: start;
  width: 100%;
  height: 100%;
  display: flex;
  > div {
    flex: 1;
    width: 100%;
    height: 100%;
    display: flex;
  }
  .use-case-item-container {
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 57px 30px;
    overflow: hidden;
  }
  .use-case-item-holder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    justify-content: center;
  }
  .use-case-item-icon-holder {
    width: 60px;
    height: 60px;
    color:white;
    > svg {
     fill: url(#shinyTransparentGray);
     color:white;
      width: 60px;
      height: 60px;
    }
  }
  .use-case-item-text-holder {
    text-align: center;
    > p {
      padding: 0;
      margin: 0;
    }
  }
`;
